export const GET_NODE_CLICK_STATE_REQUEST = "GET_NODE_CLICK_STATE_REQUEST";
export const GET_NODE_CLICK_STATE_SUCCESS = "GET_NODE_CLICK_STATE_SUCCESS";
export const GET_NODE_CLICK_STATE_FAILURE = "GET_NODE_CLICK_STATE_FAILURE";
